import { myFetch, HttpMethod } from './baseService';

export interface Torre {
  tor_codigo: string;
  tor_nombre: string;
  tor_numero_de_pisos: number;
  tor_cero: number;
}

export interface ObtenerTorresRequest {
  "unidad residencial codigo": string;
}

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

/**
 * Obtener todas las torres de una unidad residencial
 */
export const obtenerTorres = async (payload: ObtenerTorresRequest) => {
  const envelope = await myFetch<ApiEnvelope<Torre[]>>(
    'torre/ObtenerTodos',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

